module.exports = __webpack_public_path__ + "img/icon-custom-kaixin.bbde6f67.svg";